import React from 'react'
import LazyLoadForm from './LazyLoadForm'
import SetTitle from '../utils/set_title'
import Header from '../components/Headers/Header'

export default function LazyLoad() {
  SetTitle('Lazy Load')
  const description =
    "Controlla che Google veda tutti i contenuti della tua pagina, assicurati che la tua implementazione di caricamento lazy carichi tutti i contenuti pertinenti ogni volta che sono visibili nell'area visibile."

  return (
    <Header
      iconClass="ni ni-button-pause text-white"
      title="Lazy Load"
      docLink="/docs/ranking_tools/lazy-load/"
      description={description}
    >
      <LazyLoadForm />
    </Header>
  )
}